import Vue from 'vue';
import i18n from "../../../i18n";

export default {
  async createVessel({ dispatch, commit }, payload) {
    return Vue.axios
      .post(Vue.$url("vessel"), payload)
      .then((data) => {
        Vue.$log.debug("vessel created and saved under", data.id);
        commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'Vessel', 1: payload.description }), { root: true });
        dispatch('fetchVessels');
      })
  },

  async fetchVessels({ commit }) {
    return Vue.axios.get(Vue.$url("vessel"))
      .then((rsp) => commit("SET_VESSELS", rsp.data))
  },

  async fetchVesselNames({ commit }) {
    return Vue.axios.get(Vue.$url("vessel/names"))
      .then((rsp) => commit("SET_VESSEL_NAMES", rsp.data))
  },

  async fetchNextMaxCode({ commit }) {
    return Vue.axios.get(Vue.$url("vessel/max-code"))
      .then((rsp) => { 
        commit('SET_NEXT_SEQ_CODE', rsp.data)
        return rsp.data;
      })
      .catch((err) => Vue.$err(err) && commit('mShowErrorMessage', err.data.Message, { root: true }))
  },

  async updateVessel({ dispatch, commit }, payload) {
    return Vue.axios
      .put(Vue.$url("vessel/" + payload.id), payload)
      .then(() => {
        dispatch('fetchVessels');
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Vessel', 1: payload.description }), { root: true });
      })
  },

  async deleteVessel({ dispatch, commit }, payload) {
    Vue.$log.debug('trying to delete Vessel', payload.id);
    console.log(i18n.t('common.deleteViolation'));
    return Vue.axios
      .delete(Vue.$url("vessel/" + payload.id))
      .then(() => {
        dispatch('fetchVessels');
        commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.description }), { root: true });
      })
  },

}